"use client"

import { Link } from "react-router-dom"
import MiniFooter from "../../components/Layout/miniFooter"

export default function NotFound() {
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "#F9FAFB",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            maxWidth: "440px",
            width: "100%",
          }}
        >
          <h1
            style={{
              fontSize: "72px",
              fontWeight: "800",
              color: "#111827",
              marginBottom: "8px",
            }}
          >
            404
          </h1>

          <h2
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#111827",
              marginBottom: "12px",
            }}
          >
            Page not found
          </h2>

          <p
            style={{
              fontSize: "15px",
              color: "#6B7280",
              marginBottom: "18px",
            }}
          >
            The page you are looking for does not exist or has been moved.
          </p>

          {/* Company Information */}
          <p
            style={{
              fontSize: "14px",
              color: "#6B7280",
              marginBottom: "26px",
              lineHeight: "1.6",
            }}
          >
            <strong style={{ color: "#111827" }}>u2lr</strong> is a secure URL
            shortening and link management platform built by{" "}
            <strong>u2lr Software Inc.</strong> to help teams track, manage, and
            optimize their links with confidence.
          </p>

          <Link
            to="/user-dashboard"
            style={{
              display: "inline-block",
              padding: "10px 18px",
              background: "#4F46E5",
              color: "#FFFFFF",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              textDecoration: "none",
              transition: "background 0.2s ease",
            }}
          >
            Back to Dashboard
          </Link>

          {/* Optional support link */}
          <div style={{ marginTop: "18px" }}>
            <Link
              to="/contact-us"
              style={{
                fontSize: "13px",
                color: "#4F46E5",
                textDecoration: "none",
                fontWeight: "500",
              }}
            >
              Contact support
            </Link>
          </div>
        </div>
      </div>

      <MiniFooter />
    </>
  )
}
